import { AxiosRequestConfig } from 'axios'

export function setAuthorizationHeader(config: AxiosRequestConfig, authToken: string) {
  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${authToken}`
  }
}
